export default "__VITE_ASSET__C_BjgY3w__"